<template>
  <div class="jl-auc-modal">
    <div class="jl-auc-modal-body">
      <div class="jl-modal-content1">
        <div class="item">
          <div>
            <p class="text1">
              举牌金额：
              <span class="span1">¥</span>
              <span class="span2">{{price}}</span>
            </p>
            <p class="text2">是否确定举牌?</p>
          </div>
          <div class="item-footer">
            <button class="btn alt-1" @click="hanleCancel">取消</button>
            <button class="btn confim" @click="hanleConfim">
              确定
              <i class="el-icon-loading" v-if="btnloading"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ModalPlacard",
  props: ["price"],
  data() {
    return {
      btnloading: false
    };
  },
  methods: {
    hanleCancel() {
      this.$emit("cancelClick");
    },
    hanleConfim() {
      this.btnloading = true;
      this.$emit("confimClick", { type: "placard", price: this.price });
    }
  }
};
</script>

<style lang="scss" scoped>
.jl-auc-modal {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 1000;
  background-color: rgba(0, 0, 0, 0.7);
  .jl-auc-modal-body {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 390px;
    height: 236px;
    margin-left: -195px;
    margin-top: -118px;
    background-color: #fff;
    box-shadow: 0 0 18px rgba(4, 40, 104, 0.3);
    &.alt-spike {
      width: 518px;
      height: 310px;
      margin-left: -259px;
      margin-top: -155px;
    }
  }
  .jl-modal-content1 {
    display: table;
    width: 100%;
    height: 100%;
    text-align: center;
    .item {
      display: table-cell;
      vertical-align: middle;
      .text1 {
        font-size: 16px;
        color: #333;
        margin-bottom: 10px;
        span {
          color: #e50011;
          margin-right: 5px;
        }
        .span1 {
          font-size: 28px;
        }
        .span2 {
          font-size: 36px;
        }
      }
      .text2 {
        font-size: 14px;
        color: #333;
        margin-bottom: 30px;
      }
    }
    .item-footer {
      .btn {
        width: 100px;
        height: 42px;
        text-align: center;
        line-height: 42px;
        font-size: 16px;
        color: #333;
        background-color: transparent;
        border: 1px solid #333;
        margin: 0 10px;
        outline: none;
        cursor: pointer;
        &.confim {
          color: #fff;
          background-color: #e50011;
          border-color: #e50011;
        }
      }
    }
  }
}
</style>
